import React, { Component } from 'react';
import AnyModel from "../../models/anymodel";
import  PanelLayout  from "../layout/panel-layout";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import SimpleReactValidator from 'simple-react-validator';
import BFileInput from "../../helpers/bfile-input";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import moment from 'moment-jalaali';

class NewMessage extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           model:new AnyModel(this.refs),
           recieverList:null,
           Files:[]
        };
      
        this.handleTextChange = this.handleTextChange.bind(this);
        this.getData = this.getData.bind(this);
        this.handleClick= this.handleClick.bind(this);
        this.refreshModel = this.refreshModel.bind(this);
        this.updateRecieverSelect=this.updateRecieverSelect.bind(this);
        this.updateFiles=this.updateFiles.bind(this);
        

        


        SimpleReactValidator.addLocale('fa', {
            required: 'الزامی',
            integer: 'الزامی'
            
          });

        this.validator = new SimpleReactValidator({
            locale: 'fa'
          
          });

    }

    modules = {
        toolbar: [
       
          ['bold', 'italic', 'underline','strike'],
          [{ 'direction': 'rtl' }], 
          
          [{ 'align': [] }],
         
        ],
        history: {
            delay: 2000,
            maxStack: 500,
            userOnly: true
        }
      };
    
      formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent','direction','align'
        
      ];

   updateRecieverSelect(item)
   {
      
       const {model}=this.state;
       model.ToUserId=item.value;
       this.setState({
           model:model,
         
       })
   }

   updateFiles(files) {
    const {model}=this.state;  
    var files = files.map(function(file) {
      return file.name
    });
    
    model.AttachedFiles=JSON.stringify(files);
    
    this.setState({model:model,Files:files});
    
  }
    
    handleTextChange(value) {
  
        const {model}=this.state;
        model.Body=value;
        this.setState({
            model:model
        })

        this.refreshModel();
    }

   
    componentWillReceiveProps(newProps)
    {
        const {model,recieverList}=newProps;
        if(model)
        {
            this.setState({
                model:model,
            });
           

        }

        if(recieverList)
        {
            this.setState({
                recieverList:recieverList,
            });

            console.log('recieverList',recieverList);
           

        }
        
    }

    refreshModel () {
        let model = new AnyModel(this.refs);  
        this.setState({

            model:model

        });

        console.log('MODEL',model);

        
    }
    getData() {
        let model = new AnyModel(this.refs);
        return model;
    }
   
    handleClick = (e) => {
        if (this.validator.allValid()) {
            
            this.props.submitHandler(e);

        } else {
            this.validator.showMessages();
           
            this.forceUpdate();
        }
    };

    render() { 
        //const {model} = this.props;
        const {recieverList,model}= this.state;
        const {loading,error} = this.props;
    

 
        return ( 

        <PanelLayout title={"پیام"}>

           
            <div className="panel-body custom">

            <div className="panel panel-default">
               
                <div className="toolbox">

                    <Link to="/message/inbox" className="btn btn-default btn-sm"> <i className="fa fa-arrow-right"></i> بازگشت </Link>
                    &nbsp;&nbsp;
                    <button type="button" disabled ={loading } className="btn btn-default btn-sm" onClick={this.handleClick} ><i className="fa fa-save"></i>   ارسال پیام
                    
                     { loading &&
                         <i className="fa fa-spinner fa-spin"></i>
                     }

                     </button>


                
                </div>
            </div>
                
            <div class="panel panel-default">
                <div class="panel-heading">اطلاعات پیام</div>
                <div class="panel-body">

                    <form autoComplete="off" ref={c => { this.form = c }}>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-md-12">
                                        گیرنده
                                    </label>
                                    <div className="col-md-6">
                                        <Select 
                                            onChange={this.updateRecieverSelect}
                                            value ={model && recieverList && recieverList.constructor === Array ? recieverList.filter(x=>x.value== model.ToUserId) : null }                                   
                                            options={model && recieverList && recieverList.constructor === Array ? recieverList : []}
                                        
                                            clearable={true}
                                            placeholder="انتخاب کنید"
                                            noResultsText="نتیجه‌ای یافت نشد"
                                        />
                                    </div>
                                    <div className="col-md-6"></div>
                                    <input type="hidden" value={model && model.ToUserId} name="ToUserId" ref="ToUserId"></input>
                                    {this.validator.message('ToUserId', model.ToUserId, 'required|string')}
                                </div>
                                <div className="form-group">
                                    <label className="col-md-12">
                                        عنوان پیام
                                    </label>
                                    <div className="col-md-6">

                                        <input  name="Title" ref="Title" className="form-control" value={model && model.Title} type="text"></input>
                       
                                    </div>
                                    <div className="col-md-6"></div>
                                    
                                    {this.validator.message('Title', model.Title, 'required|string')}
                                   
                                </div>
                                
                                <div className="form-group">
                                    <label className="col-md-12">
                                        متن پیام
                                    </label>
                                    <div className="col-md-8">
                                    <ReactQuill
                                            
                                            modules={this.modules}
                                           
                                            formats={this.formats}
                                            style={{minHeight:250}}
                                            onChange={this.handleTextChange} />
                       
                                    </div>
                                    <div className="col-md-4"></div>
                                    <input  name="Body" ref="Body" value={model && model.Body} type="hidden"></input>
                                    {this.validator.message('Body', model.Body, 'required|string')}
                                   
                                </div>
                                <div className="form-group">
                                   
                                    <div className="col-md-8">

                                        <div class="panel panel-default">
                                            <div class="panel-heading">
                                                <a data-toggle = "collapse" href = "#attachement">
                                                    <i class="fa fa-paperclip" ></i> پیوست ({this.state.Files.length})
                                                </a>                   
                                            </div>
                                            <div id = "attachement" className = "panel-collapse collapse">
                                                <div class="panel-body">
                                                    <BFileInput  updateImagesHandler={this.updateFiles}></BFileInput>
                                                    <input type="hidden" value={model && model.AttachedFiles} name="AttachedFiles" ref="AttachedFiles"></input>
                                                            
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    
                                    <div className="col-md-4"></div>
                                  
                                   
                                </div>

                            </div>
                        </div>
                       
                        
                        
                       
                    </form>
                
                
                </div>
            </div>
               
            </div>
        </PanelLayout>





        );
    }
}

 
export default NewMessage;